import React from 'react';
import logoUrl from './assets/polyrth-logo.png';

export default function TopNav({ active, onNavigate }) {
  const isHome = active === 'home';
  const isInsiders = active === 'insiders';
  const isChecker = active === 'checker';

  return (
    <div className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/50 backdrop-blur-md">
      <div className="mx-auto max-w-6xl px-6 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 select-none">
          <img
            src={logoUrl}
            alt="polyrth"
            className="h-7 w-7 rounded-md border border-white/10 bg-black/20"
            draggable="false"
          />
          <div className="text-sm font-semibold tracking-wide text-white">polyrth</div>
        </div>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => onNavigate?.('home')}
            className={`rounded-lg px-3 py-2 text-sm font-semibold border transition ${
              isHome
                ? 'border-white/30 bg-white/15 text-white'
                : 'border-white/15 bg-white/5 text-white/85 hover:bg-white/10'
            }`}
          >
            Home
          </button>
          <button
            type="button"
            onClick={() => onNavigate?.('checker')}
            className={`rounded-lg px-3 py-2 text-sm font-semibold border transition ${
              isChecker
                ? 'border-yellow-300/40 bg-yellow-300/10 text-yellow-100'
                : 'border-white/15 bg-white/5 text-white/85 hover:bg-white/10'
            }`}
          >
            Check status
          </button>
          
        </div>
      </div>
    </div>
  );
}

